 <template>
	<div id="usereditdpa"class="oh">
		<leftnav class="fl" mkcode="F" itemcode="F-MMXG"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''" >
			<govheader></govheader>
			<div class="index_left_centerpage"> 
			<div class="whitebox right_topbox" style="height:840px;" >
				<div class="right_boxtitle">
					<span class="fl right_title">密码修改</span>  
					<video-teaching :type="6" style="line-height:46px"></video-teaching>
				</div> 
				<div class="usereditdpa gov_usereditdpa">
					<div class="inputbox">
						<label>原始密码</label><input type="password" placeholder="原始密码" @change="editbtn=true" v-model="oldpassw">
					</div>
					<div class="inputbox">
						<label>新密码</label><input type="password" placeholder="新密码" @change="editbtn=true" v-model="newpassw">
					</div>
					<div class="inputbox">
						<label>确认新密码</label><input type="password" placeholder="确认新密码" @change="editbtn=true" v-model="newpassw1">
					</div> 
					<div class="inputbox1"> 
						<div :class="{'submitbtn':true,'editsave':editbtn && !loading } " @click="saveeditFun()" style="margin-top:0;">确认修改</div>
					</div>
					<p class="errortext inputbox1">{{errortext}}</p>
				</div>
				
				
			</div>
			</div>
		</div>
		
	</div>
</template> 
<script>
import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
	  name: 'editPassword',
	  computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	  data(){return{
				userdata:{},
				title:'用户中心-修改密码',
				editbtn:false,
				oldpassw:"",newpassw:'',newpassw1:'',errortext:'',
				loading:false,
			}},
		 created() {
		 	this.userdata=this.getuseriformation();
		 },
			methods:{ 
				saveeditFun(){
					if(!this.loading){ 
					if(this.editbtn){ 
						if(this.newpassw.length==0 || this.oldpassw.length==0 || this.newpassw1.length==0){
							this.errortext='密码不能为空';return;
						}
						if(this.newpassw1!=this.newpassw){
							this.errortext='两次新密码不一致';return;
						}
						var _this=this;
						this.loading=true; 
						var ajaxurl=this.$api.cyl.usercenter.updatepassword();
						$.ajax({
							type:"POST",
							url:ajaxurl,
							data:{oldpw:this.oldpassw,newpw:this.newpassw1,},
							headers:{AuthToken:this.userdata.token },
							success:function(res){ 
								console.log(res); 
								if(res.success){   
									_this.logout();
								}else{
										_this.loading=false;
										_this.errortext=res.msg; 
								} 
							} 
						});	 
						console.log(this.oldpassw,this.newpassw1);
					}
					
					}
				}
				
				
			}
	}  
</script>

<style>
	
</style>



